export const WA_NUMBER = "5511952432340";
export const WA_MESSAGE =
  "Olá! Vim pelo site da KRONO e quero um orçamento gratuito de pintura.";
export const WA_LINK = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;
export const EMAIL = "krono.pinturas@gmail.com";
export const INSTAGRAM_HANDLE = "@krono.paint";
export const INSTAGRAM_URL = "https://instagram.com/krono.paint";
export const CNPJ = "66.153.182/0001-49";
export const ZONES = [
  "Zona Sul",
  "Zona Oeste",
  "Zona Norte",
  "Zona Leste",
  "Centro & Expandido",
  "ABC (Santo André, SBC, SCS)",
  "Osasco & Barueri",
  "Guarulhos",
];
